import { format, parseISO } from "date-fns";

export const formatTimeStampToHoras = (data: string) => {
    const parsedDataToIso = parseISO(data || new Date().toISOString());
    const parsedDataFormated = format(parsedDataToIso, "dd/MM/yy HH:mm");
    return parsedDataFormated;
};
